module.exports = __webpack_public_path__ + "static/MainVisual-9af3dbe4c84b1d306411e56c1a3b1ef8.png";